/**
 * Storage keys used by the 'React OAuth2 Code PKCE' package.
 */
enum RocpStorageKey {
  AUTH_STATE = 'ROCP_auth_state',
  TOKEN = 'ROCP_token',
}

export default RocpStorageKey;
